import { render } from "./Projects.vue?vue&type=template&id=19515597&scoped=true"
import script from "./Projects.vue?vue&type=script&lang=js"
export * from "./Projects.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-19515597"

export default script